import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TokenService } from '../services/token/token.service';

@Injectable()
export class WebInterceptor implements HttpInterceptor {
	bypassUrl: string[] = [
		'viacep.com.br',
		'servicodados.ibge.gov.br',
		'sanusuploadcargaplanilha.s3.us-east-1.amazonaws.com',
	];

	constructor(private readonly tokenService: TokenService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const token = this.tokenService.loadAccessToken();

		if (token && !this.bypassUrl.includes(request.url.split('/')[1])) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
				},
			});
		}

		return next.handle(request);
	}
}
